import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';

export const authGuard: CanActivateFn = async (_route, _state) => {
  const authService = inject(AuthenticationService);
  const router = inject(Router);

  try {
    const token = await authService.getToken();

    if (token === null) {
      // No valid token, return UrlTree to redirect to login
      return router.parseUrl('/login');
    }

    // Valid token found, allow access
    return true;
  } catch (error) {
    // Error getting token, return UrlTree to redirect to login
    console.error('Auth guard error:', error);
    return router.parseUrl('/login');
  }
};
